<script lang="ts">
export default { name: 'PinCreationModal' };
</script>

<script lang="ts" setup>
//COMPONENTS
import GModalAlert from '@/components/GModalAlert/index.vue';
import { GButton } from '@flash-global66/g-button';

// COMPOSABLES
import { usePinCreationModal } from './usePinCreationModal';

defineProps({ modelValue: Boolean });
const emits = defineEmits(['update:modelValue']);

const { goToCreatePin } = usePinCreationModal(emits);
</script>

<template>
  <g-modal-alert
    :show="modelValue"
    disable
    title="¡Creamos el business PIN para la seguridad de tu empresa!"
    class-content="pb-4 pt-8 max-w-lg px-10 my-8  bg-white rounded-lg"
    data-test="pin:creation-modal"
  >
    <template #body>
      <div class="text-secondary-txt text-3 text-center">
        <p>
          Incorporamos un segundo factor de autentificación para aumentar la
          seguridad de tu operatoria y el resguardo de tu información.
        </p>
        <hr class="my-4" />
        <p>
          El PIN es un herramienta personal y no debe ser compartido. Asegúrate
          de recordarlo ya que será solicitado a la hora de realizar cualquier
          operación.
        </p>
        <p class="text-4 text-terciary-txt text-center font-bold mt-2">
          ¡Olvídate de los correos de confirmación!
        </p>
      </div>
    </template>
    <template #actions>
      <div class="grid gap-4">
        <g-button
          class="mt-4"
          full
          @click="goToCreatePin"
          data-test="button:create-pin"
          >Empezar</g-button
        >
      </div>
    </template>
  </g-modal-alert>
</template>
